import React from "react";
import { Flame, Coins, Zap, Trophy } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function LanguageHUD({ profile, className = "" }) {
  const t = useT();
  if (!profile) return null;
  const { xp = 0, coins = 0, streak_days = 0, level = 1, xp_in_level = 0, xp_to_next = 50, next_threshold = 50 } = profile;
  const rangeSize = xp_in_level + xp_to_next;
  const pct = rangeSize ? Math.min(100, Math.round((xp_in_level / rangeSize) * 100)) : 0;
  const plural = streak_days !== 1 ? "s" : "";

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-3 ${className}`} data-testid="language-hud">
      <div className="flex items-center gap-3 bg-white rounded-xl border border-[#E5E7EB] px-4 py-3 shadow-sm">
        <div className="h-9 w-9 rounded-lg bg-[#F4B81F]/15 text-[#B45309] flex items-center justify-center">
          <Zap className="h-5 w-5" strokeWidth={2} />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">{t("lang.hud.xp_total")}</p>
          <p className="font-heading text-xl text-[#1A1A1A] leading-tight" data-testid="hud-xp">{xp}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 bg-white rounded-xl border border-[#E5E7EB] px-4 py-3 shadow-sm">
        <div className="h-9 w-9 rounded-lg bg-[#FFD87A]/25 text-[#8C6B10] flex items-center justify-center">
          <Coins className="h-5 w-5" strokeWidth={2} />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">{t("lang.hud.coins")}</p>
          <p className="font-heading text-xl text-[#1A1A1A] leading-tight" data-testid="hud-coins">{coins}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 bg-white rounded-xl border border-[#E5E7EB] px-4 py-3 shadow-sm">
        <div className={`h-9 w-9 rounded-lg ${streak_days > 0 ? "bg-[#DC2626]/15 text-[#DC2626]" : "bg-[#F3F4F6] text-[#9CA3AF]"} flex items-center justify-center`}>
          <Flame className="h-5 w-5" strokeWidth={2} />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">{t("lang.hud.streak")}</p>
          <p className="font-heading text-xl text-[#1A1A1A] leading-tight" data-testid="hud-streak">
            {t("lang.hud.streak_days", { n: streak_days, plural })}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 bg-white rounded-xl border border-[#E5E7EB] px-4 py-3 shadow-sm">
        <div className="h-9 w-9 rounded-lg bg-[#1B2E7A]/10 text-[#1B2E7A] flex items-center justify-center">
          <Trophy className="h-5 w-5" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">{t("lang.hud.level", { n: level })}</p>
          <div className="w-full h-1.5 bg-[#F3F4F6] rounded-full overflow-hidden mt-1">
            <div
              className="h-full bg-[#1B2E7A] rounded-full transition-all duration-500"
              style={{ width: `${pct}%` }}
              data-testid="hud-level-bar"
            />
          </div>
          <p className="text-[10px] text-[#6B7280] mt-0.5">
            {t("lang.hud.xp_to_next", { xp: xp_to_next, next: level + 1 })}
          </p>
        </div>
      </div>
    </div>
  );
}
